import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function CategoryNavigation() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            分区导航
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            按分区快速浏览，选择您感兴趣的内容版块开启探索之旅
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-100 rounded-lg p-6 flex items-start gap-4 cursor-pointer transition-all duration-300 hover:bg-background-200/70"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0 group-hover:bg-accent-500 group-hover:text-white transition-all duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}